<template>
	<div class="u-container">
		<h2 class="page-sub-title">텐텐 쿠폰 스탬프</h2>

		<div class="stamp-container">
			<div class="stamp-background-grid stamp-grid">
				<div
					v-for="(item, index) in stampGridItemList"
					:key="index"
					class="stamp-background-grid__item stamp-grid__item"
				>
					<div
						class="stamp-background-grid__inner"
						:style="stampGridItemInnerStyles"
					></div>
				</div>

				<!-- 스탬프 현황 -->
				<AsStampStatusList />
			</div>

			<div class="mt-5">
				<AppButton color="primary" block @click="goToStampHistory"
					>텐텐쿠폰 스템프 히스토리</AppButton
				>
			</div>
		</div>
	</div>
</template>

<script>
import AppButton from '@/components/App/AppButton';
import AsStampStatusList from './AsStampStatusList';

import logoGraphic from '@/assets/images/common/logo-graphic.svg';

export default {
	components: {
		AppButton,
		AsStampStatusList,
	},
	computed: {
		stampGridItemList() {
			return Array.from({ length: 10 }, () => '');
		},
		stampGridItemInnerStyles() {
			return { backgroundImage: `url(${logoGraphic})` };
		},
	},
	methods: {
		goToStampHistory() {
			this.$router.push({ name: 'asStampHistory' });
		},
	},
};
</script>
